

/* tslint:disable */




import { FlowchartComponentDto } from './FlowchartComponentDto';
import { FlowchartElementType } from './FlowchartElementType';
import { GuidelineActionDto } from './GuidelineActionDto';
import { GuidelineCriterionDto } from './GuidelineCriterionDto';

export class FlowchartStartNodeDto extends FlowchartComponentDto {
    guidelineActionId?: string | null;
    guidelineAction?: GuidelineActionDto;
    guidelineCriteriaId?: string | null;
    guidelineCriteria?: GuidelineCriterionDto;
    rule?: string;
    rulePrettyfied?: string;
    elementType?: FlowchartElementType;

}

